<template>
  <div class="container" :style="customStyle">
    <div class="call-menu-heading" @mouseenter="hover = true" @mouseleave="hover = false">
      <div class="call-menu-heading-normal" @click="showList = true">
        <img src="@/assets/images/call_menu_title.svg" />
        Call Menu
      </div>
      <div v-if="showList" class="background-container" @click="showList = false" />
      <div v-if="showList" class="list">
        <div class="section-title">Edit routing to</div>

        <div class="list-item" @mouseover="hoverPerson = true" @mouseleave="hoverPerson = false">
          <call-flow-button-icon :action="ACTION_TYPES.ACTION_PERSON" />
          <span class="item-name">Call a person</span>
          <img src="@/assets/images/next.svg" alt="next" />

          <div v-if="hoverPerson" class="list more">
            <div
              v-for="(person, index) in team"
              :key="index"
              class="list-item"
              @click="onClickItem(ACTION_TYPES.ACTION_PERSON, person.id)"
            >
              <div class="item-avatar" :style="'background-color: ' + person.avatarColor">
                {{ person.avatarName }}
              </div>
              <div class="item-name">
                {{ person.name }}
              </div>
            </div>
          </div>
        </div>

        <div class="list-item" @mouseover="hoverGroup = true" @mouseleave="hoverGroup = false">
          <call-flow-button-icon :action="ACTION_TYPES.ACTION_GROUP" />
          <span class="item-name">Call group</span>
          <img src="@/assets/images/next.svg" alt="next" />

          <div v-if="hoverGroup" class="list more">
            <div
              v-for="(group, index) in groups"
              :key="index"
              class="list-item"
              @click="onClickItem(ACTION_TYPES.ACTION_GROUP, group.id)"
            >
              <div class="item-avatar" :style="'background-color: ' + group.avatarColor">
                {{ group.avatarName.charAt(0).toUpperCase() }}
              </div>
              <div class="item-name">
                {{ group.name }}
              </div>
            </div>
          </div>
        </div>

        <div class="list-item" @click="onClickItem(ACTION_TYPES.ACTION_VOICEMAIL, null)">
          <call-flow-button-icon :action="ACTION_TYPES.ACTION_VOICEMAIL" />
          <span class="item-name">
            Send to voicemail
          </span>
        </div>

        <div class="list-item" @click="onClickItem(ACTION_TYPES.ACTION_HANGUP, 'hang-up')">
          <call-flow-button-icon :action="ACTION_TYPES.ACTION_HANGUP" />
          <span class="item-name">Hang up</span>
        </div>
      </div>
    </div>
    <div class="call-menu-body">
      <div v-if="!callMenu.target" class="menu-item not-ready" @click="onEditRecording">
        <img src="@/assets/images/recording_needed.svg" alt="recording" />
        <div>
          <h5>Add greeting</h5>
          <p>No greeting added</p>
        </div>
      </div>
      <div
        v-if="callMenu.target && !hoverRecord"
        class="menu-item"
        @click="onEditRecording"
        @mouseenter="hoverRecord = true"
      >
        <img src="@/assets/images/recording_created.svg" alt="recording" />
        <div>
          <h5>{{ hoverRecord ? 'Edit Greeting' : 'Greeting' }}</h5>
          <p>{{ subInfo }}</p>
        </div>
      </div>
      <div
        v-if="callMenu.target && hoverRecord"
        class="menu-item edit"
        @click="onEditRecording"
        @mouseleave="hoverRecord = false"
      >
        <img src="@/assets/images/edit.svg" class="edit-icon" alt="edit" />
        <h5>Edit Greeting</h5>
      </div>

      <div v-if="!callMenu.target" class="menu-item item-disable">
        <img src="@/assets/images/routing_disabled.svg" alt="routing" />
        <div>
          <h5>Extensions</h5>
          <p>0 line created</p>
        </div>
      </div>
      <div v-if="callMenu.target && !callMenu.numbers.length" class="menu-item not-ready" @click="onEditNumbers">
        <img src="@/assets/images/routing_needed.svg" alt="routing" />
        <div>
          <h5>Extensions</h5>
          <p>0 line created</p>
        </div>
      </div>
      <div
        v-if="callMenu.target && callMenu.numbers.length && !hoverNumbers"
        class="menu-item"
        @click="onEditNumbers"
        @mouseenter="hoverNumbers = true"
      >
        <img src="@/assets/images/routing_created.svg" alt="routing" />
        <div>
          <h5>Extensions</h5>
          <p>{{ callMenu.numbers.length }} lines created</p>
        </div>
      </div>
      <div
        v-if="callMenu.target && callMenu.numbers.length && hoverNumbers"
        class="menu-item edit"
        @click="onEditNumbers"
        @mouseleave="hoverNumbers = false"
      >
        <img src="@/assets/images/edit.svg" class="edit-icon" alt="edit" />
        <h5>Edit Extensions</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { formatMMSS, getAvatarColor } from '@/utils';
import { ACTION_TYPES } from '@/constants';

import CallFlowButtonIcon from './CallFlowButtonIcon';

import { mapGetters } from 'vuex';
import { S_USERS } from '@/graphql';
export const formatNameForAvatar = (firstName, lastName) => {
  if (firstName && lastName) {
    return firstName.charAt(0) + lastName.charAt(0);
  }
  if (firstName) {
    return firstName.charAt(0);
  }
  if (lastName) {
    return lastName.charAt(0);
  }
  return 'U';
};

export const formatFullName = (firstName, lastName) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  if (firstName) {
    return firstName;
  }
  if (lastName) {
    return lastName;
  }
  return 'Unnamed Contact';
};

export default {
  components: { CallFlowButtonIcon },
  name: 'CallFlowMenu',
  props: {
    callMenuNumber: {
      required: false,
      type: Number
    },
    callMenu: Object,
    customStyle: String,
    team: Array,
    groups: Array,
    action: String,
    type: String,
    onEditRecording: Function,
    onEditNumbers: Function,
    onDeleteCallMenu: Function
  },
  async created() {
    try {
      const result = await this.$apollo.mutate({
        mutation: S_USERS
      });

      this.users = result.data.users.map((user) => {
        const { first_name, last_name, id } = user;
        return {
          ...user,
          avatarColor: getAvatarColor(),
          avatarName: formatNameForAvatar(first_name, last_name),
          fullName: formatFullName(first_name, last_name)
        };
      });
    } catch (err) {
      console.log(err);
    }
  },
  data: () => ({
    hover: false,
    hoverRecord: false,
    hoverNumbers: false,
    showList: false,
    users: [],
    istext: false,
    istitle: false,
    hoverPerson: false,
    hoverGroup: false,
    ACTION_TYPES
  }),
  computed: {
    duration() {
      return formatMMSS(this.callMenu.target.duration);
    },
    subInfo() {
      if (!this.callMenu.target) {
        return '';
      } else {
        const { tab, duration } = this.callMenu.target;
        return tab !== 'Text to audio' ? `${tab} - ${formatMMSS(duration ? duration : 0)}` : tab;
      }
    }
  },
  methods: {
    onClickItem(action, data) {
   
      this.showList = false;
      this.hoverPerson = false;
      this.hoverGroup = false;
      return this.$emit('select-action', action, data, 'large', this.callMenuNumber, false,  true);
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 320px;
  margin: 0 auto;
  cursor: pointer;
  text-align: center;
  position: relative;
  background: #fafbfc;
  box-shadow: 0px 20px 40px rgba(83, 95, 119, 0.15), 0px 2px 10px rgba(83, 95, 119, 0.15);
  border-radius: 5px;
  overflow: visible;
  .call-menu-heading {
    width: 100%;
    height: 36px;
    background: #ec8145;
    border-radius: 5px 5px 0px 0px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    text-align: center;
    letter-spacing: -0.02em;
    color: #fafbfc;

    .call-menu-heading-normal {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 8px;
      }
    }

    .call-menu-heading-delete {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #be2323;
      img {
        margin-left: 5px;
      }
    }

    .background-container {
      position: fixed;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
    }

    .list {
      text-align: left;
      position: absolute;
      left: 80%;
      top: 0;
      width: 225px;
      background: #ffffff;
      border: 0.2px solid #d4d6d8;
      box-shadow: 2px 2px 10px rgba(83, 95, 119, 0.15);
      border-radius: 5px;
      padding: 10px 0;
      z-index: 100;

      &.more {
        left: 210px;
        top: 0;
        bottom: unset;
        max-height: 250px;
        overflow: auto;
      }

      .section-title {
        display: block;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: -0.01em;
        color: $colorPlaceholder;
        margin-left: 15px;
      }

      .list-item {
        position: relative;
        width: 100%;
        height: 45px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        padding: 10px 20px;
        &:hover {
          background-color: $colorBack;
        }

        .item-avatar {
          width: 25px;
          height: 25px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 5px;
          font-weight: 500;
          font-size: 12px;
          line-height: 15px;
          text-align: center;
          letter-spacing: 0.03em;
          color: #ffffff;
        }

        .item-name {
          flex: 1;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.01em;
          margin-left: 15px;
          color: $colorText;
        }
      }
    }
  }

  .call-menu-body {
    padding: 25px;
    .menu-item {
      display: flex;
      height: 49px;
      padding: 0;
      text-align: left;
      img {
        margin-right: 10px;
      }
      h5 {
        font-weight: 600;
        font-size: 14px;
        line-height: 130%;
        letter-spacing: -0.02em;
        color: #606c82;
        margin: 0;
      }
      p {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.02em;
        color: #8d9fbd;
        margin-top: 2px;
      }
    }

    .menu-item.edit {
      display: flex;
      align-items: center;
      img {
        margin-left: 17px;
        margin-right: 27px;
      }
    }

    .menu-item:first-child {
      border-bottom: 1px solid #d2dae9;
      padding-bottom: 15px;
      margin-bottom: 20px;
      height: 60px !important;
    }
    .menu-item.not-ready {
      h5 {
        color: #0d1d3f;
      }
    }
    .menu-item.item-disable {
      h5 {
        color: #8d9fbd;
      }
    }
  }
}
</style>
